import { SINGLE_SUB_CATEGORY } from "../types/singleSubCategory.type";

const initialState = {
  loading: true,
  data: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SINGLE_SUB_CATEGORY.SUCCESS_FETCH:
      return {
        loading: false,
        data: action.payload,
        error: "",
      };
    case SINGLE_SUB_CATEGORY.FAIL_FETCH:
      return {
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return { ...state };
  }
};
export default reducer;
